import React from 'react'
import { Box, Button, HStack, Icon, Text, VStack } from '@chakra-ui/react'
import { CheckCircleIcon } from '@chakra-ui/icons'

interface IncidentGatewayProps {
  value: 'yes' | 'no' | null
  onChange: (value: 'yes' | 'no' | null) => void
}

const IncidentGateway: React.FC<IncidentGatewayProps> = ({
  value,
  onChange,
}) => {
  const handleYes = () => {
    onChange(value === 'yes' ? null : 'yes')
  }

  const handleNo = () => {
    onChange(value === 'no' ? null : 'no')
  }

  return (
    <VStack align='stretch' spacing={3}>
      <Text fontWeight='medium' fontSize='md'>
        Did anything notable happen to you this month — an injury, illness,
        surgery, hospitalisation, or significant stressor?
      </Text>
      <HStack spacing={3}>
        <Button
          size='sm'
          variant={value === 'yes' ? 'solid' : 'outline'}
          colorScheme='orange'
          onClick={handleYes}
          data-active={value === 'yes' ? 'true' : undefined}
        >
          Yes, something happened
        </Button>
        <Button
          size='sm'
          variant={value === 'no' ? 'solid' : 'outline'}
          colorScheme='green'
          onClick={handleNo}
          data-active={value === 'no' ? 'true' : undefined}
        >
          No, nothing to report
        </Button>
      </HStack>
      {value === 'yes' && (
        <Text fontSize='sm' color='gray.500'>
          Select each category that applies, then choose from the options that
          appear.
        </Text>
      )}
      {value === 'no' && (
        <Box bg='green.50' borderRadius='md' p={4}>
          <HStack spacing={3}>
            <Icon as={CheckCircleIcon} color='green.600' boxSize={5} />
            <Box>
              <Text fontWeight='semibold' color='green.800'>
                Incident-free month recorded
              </Text>
              <Text fontSize='sm' color='green.600'>
                No incidents will be logged for this month.
              </Text>
            </Box>
          </HStack>
        </Box>
      )}
    </VStack>
  )
}

export default IncidentGateway
